// Keep provider-owned widgets intact when the bag opens or its lines change.
// Providers still own consent, pricing, and every protection/donation mutation.
(() => {
  if (window.PocketCartApps) return;

  function placeImpactBadge() {
    const badge = document.querySelector('[data-cart-impact-badge]');
    const home = document.querySelector('[data-cart-impact-home]');
    if (!badge || !home) return;
    const page = [...document.querySelectorAll('[data-cart-impact-slot]')]
      .find(slot => !slot.closest('[data-bag-drawer]'));
    const bagOpen = document.querySelector('[data-bag-drawer]')?.open;
    // Move the original node. Cloning would duplicate app IDs and lose listeners.
    const target = bagOpen ? home : page || home;
    const body = target.querySelector('.bag-impact-body') || target;
    if (badge.parentElement !== body) body.append(badge);
    target.hidden = target.dataset.impactEnabled !== 'true';
  }

  ['pocket:bag-opened', 'pocket:bag-closed', 'pocket:cart-updated', 'shopify:section:load']
    .forEach(name => document.addEventListener(name, placeImpactBadge));
  document.addEventListener('shopify:section:unload', event => {
    const badge = document.querySelector('[data-cart-impact-badge]');
    const owner = [...document.querySelectorAll('[data-cart-section]')]
      .find(section => section.dataset.sectionId === badge?.dataset.impactOwner);
    const originalSlot = owner?.querySelector('[data-cart-impact-slot]');
    if (!badge || !originalSlot) return;
    // Return it before the editor replaces either section, so old app instances
    // cannot survive outside the section that owns them.
    if (event.target.contains(originalSlot) || event.target.contains(badge)) (originalSlot.querySelector('.bag-impact-body') || originalSlot).append(badge);
  });

  document.addEventListener('click', event => {
    const close = event.target.closest('[data-cart-impact-close]');
    const panel = close?.closest('[data-cart-impact-details]');
    if (!panel) return;
    panel.open = false;
    panel.querySelector('summary')?.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest('[data-cart-impact-details][open]');
    if (!panel) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    panel.open = false;
    panel.querySelector('summary')?.focus({ preventScroll: true });
  }, true);
  document.addEventListener('pocket:bag-closed', () => {
    document.querySelectorAll('[data-bag-drawer] [data-cart-impact-details]').forEach(panel => { panel.open = false; });
  });

  // Route (and other cart apps) makes its own Shopify Ajax requests. Observe
  // completed writes and refresh only our display. No fetch/XHR monkey patch,
  // no repeated polling, and no automatic products or cart writes from here.
  let timer = null, revision = 0, refreshing = false, stopped = false;
  function scheduleRefresh() {
    if (stopped) return;
    revision++;
    clearTimeout(timer);
    timer = setTimeout(syncCart, 180);
  }
  async function syncCart() {
    timer = null;
    if (stopped || refreshing) return;
    if (!window.PocketCart) return;
    if (window.PocketCart.busy) {
      timer = setTimeout(syncCart, 180);
      return;
    }
    const started = revision;
    refreshing = true;
    try { await window.PocketCart.refresh(); }
    catch (error) { console.warn('Cart app display refresh:', error); }
    finally {
      refreshing = false;
      if (!stopped && started !== revision) {
        clearTimeout(timer);
        timer = setTimeout(syncCart, 180);
      }
    }
  }

  let observer;
  if ('PerformanceObserver' in window) {
    try {
      observer = new PerformanceObserver(list => {
        if (list.getEntries().some(entry => {
          if (!['fetch', 'xmlhttprequest'].includes(entry.initiatorType)) return false;
          if (entry.responseStatus && (entry.responseStatus < 200 || entry.responseStatus >= 300)) return false;
          const url = new URL(entry.name, location.href);
          return url.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
        })) scheduleRefresh();
      });
      observer.observe({ type: 'resource', buffered: false });
    } catch { /* Older browsers retain normal bag-open and theme cart refreshes. */ }
  }

  window.addEventListener('pagehide', () => { stopped = true; clearTimeout(timer); });
  window.addEventListener('pageshow', () => { stopped = false; placeImpactBadge(); });
  window.PocketCartApps = { placeImpactBadge };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeImpactBadge);
  else placeImpactBadge();
})();
